import { Box, Chip, Divider, MenuItem, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Dialog } from '@/components/organisms/common/Notification/Releases/Dialog'
import { useRelease } from '@/components/organisms/common/Notification/Releases/hooks'
import { StackRow } from '@/components/uiParts/legacy/Stack/Row'
import { DialogContext } from '@/contexts/Dialog'
import { Release } from '@api/models'

export const Releases = () => {
  const { t } = useTranslation()
  const { open } = useContext(DialogContext)
  const { releaseList, onSelect } = useRelease()
  const openDetail = (item: Release) => {
    open({
      title: t('release_detail'),
      maxWidth: 'xl',
      render: () => {
        return <Dialog release={item} />
      },
    })
  }

  return (
    <Box maxHeight="20vh" overflow="auto">
      <Box px={2} py={1} sx={{ backgroundColor: grey[100] }}>
        <Box fontWeight="bold" fontSize={16}>
          {t('release')}
        </Box>
      </Box>
      <Divider />
      {releaseList.length === 0 ? (
        <Box px={2} py={1}>
          {t('theres_no_item_to_display')}
        </Box>
      ) : (
        releaseList.map((item) => (
          <MenuItem key={item.id} onClick={onSelect(item, openDetail)}>
            <Box>
              <StackRow>
                <Chip
                  size="small"
                  color={item.is_read ? 'default' : 'primary'}
                  label={item.is_read ? t('read') : t('unread')}
                />
                <Box fontWeight="bold" fontSize={14}>
                  {item.title}
                </Box>
              </StackRow>
              <Typography>
                {new Date(item.updated_at).toLocaleString()}
              </Typography>
            </Box>
          </MenuItem>
        ))
      )}
    </Box>
  )
}
